import { Utilservice } from '@core/services/util.service';
import * as moment from 'moment';

class CanTransmitVisitsOfWeekService {
  private validateIfIsWeekIsNextWeek(
    nextWeekOfDuloren: moment.Moment[],
    weekStart: moment.Moment,
    weekEnd: moment.Moment
  ){
    const primeiroDiaProximaSemana = nextWeekOfDuloren[0];
    const ultimoDiaProximaSemana = nextWeekOfDuloren[nextWeekOfDuloren.length -1]
    console.log("inicioP",primeiroDiaProximaSemana);
    console.log("endU",ultimoDiaProximaSemana);
    console.log("inicio",weekStart);
    console.log("end",primeiroDiaProximaSemana.isSameOrAfter(weekStart) &&
    ultimoDiaProximaSemana.isSameOrBefore(weekEnd));
    return primeiroDiaProximaSemana.isSameOrAfter(weekStart) &&
    ultimoDiaProximaSemana.isSameOrBefore(weekEnd)
  }

  public execute(
    nextWeekOfDuloren: number[],
    weekStart: moment.Moment,
    weekEnd: moment.Moment,
    visits: any[]
  ){
    const proximaSemana = Utilservice.convertTimestampArrayToMoment(nextWeekOfDuloren);
    let canTrasmit = true;
    console.log("proxima semana ", nextWeekOfDuloren);
    console.log("visitas ", visits);
    if(this.validateIfIsWeekIsNextWeek(proximaSemana, weekStart, weekEnd)){
      canTrasmit = !proximaSemana.some(momentDate => {
        const visitsOfDay: any[] = visits.filter( d => moment(d.dataAgendamento).day() == momentDate.day() ) || [];

        return visitsOfDay.length < 8;
      })
    }else{
      canTrasmit = false;
    }

    return canTrasmit;
  }
}

export {CanTransmitVisitsOfWeekService};
